(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('DataElementDetailController', DataElementDetailController);

    DataElementDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DataElement', 'Element', 'Formulaire', 'AutreActivite'];

    function DataElementDetailController($scope, $rootScope, $stateParams, previousState, entity, DataElement, Element, Formulaire, AutreActivite) {
        var vm = this;

        vm.dataElement = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bhsApp:dataElementUpdate', function(event, result) {
            vm.dataElement = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
